// This is temprory UAT link. Needs to revert back to prod 'https://www.pailottery.com/';
const portalUri = 'https://www.pailottery.com/';

export default portalUri;
